import { useLastVisited } from "hooks";
import { useState, createContext, useContext } from "react";
import { removeLocalStorage } from "utils/localStorageUtils";

const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [userData, setUserData] = useState({});
  const [orgRolesData, setOrgRolesData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [instructionModalStep, setInstructionModalStep] = useState(0);

  const { clearLastVisited } = useLastVisited();

  const handleSignOut = () => {
    removeLocalStorage("suhail_user_token");
    removeLocalStorage("user_role");
    removeLocalStorage("tokenExpiration");
    clearLastVisited();
  };

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        orgRolesData,
        setOrgRolesData,
        showModal,
        setShowModal,
        instructionModalStep,
        setInstructionModalStep,
        handleSignOut,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  return useContext(UserContext);
};
